// Project: GSSC Pilot Front-end
// Filename: helpers.js
// Copyright European Space Agency, 2020
// This file is part of the source code package for contract PO PO 5001024866
// No part of the package, including this file, may be copied, modified,
// propagated, or distributed without prior approval by ESA.
export default {
  checkErrMessage(data) {
    if (typeof data === 'object') {
      if (Object.keys(data)[0] == 'message') {
        return true;
      }
      if (Object.keys(data)[0] == 'error') {
        return true;
      }
      if (data.status && data.status != 200 && !isNaN(data.status)) {
        return true;
      }
    }
    return false;
  },
  getCleanLabel(apiLabel) {
    let cleanLabel = apiLabel
      .replace(/_/g, ' ')
      .replace('metadata', ' ')
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.substring(1))
      .join(' ');
    return cleanLabel === 'Doi' ? cleanLabel.toUpperCase() : cleanLabel;
  },
  getIdFromLabel(cleanLabel) {
    let idLabel = cleanLabel.replace(/ /g, '_').toLowerCase();
    // console.log("getIdFromLabel -> idLabel", idLabel)
    return idLabel;
  },
  objectFromArrayOfObjects(inputArray) {
    //gets object from array of objects
    //overwrites if duplicates
    let outObj = inputArray.reduce((a, c) => ({ ...a, ...c }), Object.create(null));
    return outObj;
  },
  objectFromArrayOfObjectsHandleDuplicates(inputArray) {
    //gets object from array of objects
    //converts duplicates to arrays
    let outObject = {};
    inputArray.forEach(paramObj => {
      const paramKey = Object.keys(paramObj)[0];
      if (paramKey in outObject) {
        if (!Array.isArray(outObject[paramKey])) {
          outObject[paramKey] = [outObject[paramKey]];
        }
        outObject[paramKey].push(paramObj[paramKey]);
      } else {
        outObject[paramKey] = paramObj[paramKey];
      }
    });
    return outObject;
  },
  license(testString) {
    // if there is a URL, format = [ text | URL ]
    // otherwise just display text

    const matches = testString ? testString.match(/\[(.+)\|(.+)\]/) : '';
    if (matches && matches.length == 3) {
      return {
        text: matches[1].trim(),
        url: matches[2].trim()
      };
    } else if (matches !== '') {
      return {
        text: testString,
        url: null
      };
    } else {
      return 'Not Applicable';
    }
  },
  dateFromDay(year, day) {
    let date = new Date(20 + year, 0); // initialize a date in `year-01-01`
    date = new Date(date.setDate(day)); // add the number of days
    return (
      date.getDate().toString() +
      '/' +
      (date.getMonth() + 1).toString() +
      '/' +
      date.getFullYear().toString()
    );
  },
  isJsonString(str) {
    try {
      var json = JSON.parse(str);
      return typeof json === 'object';
    } catch (e) {
      return false;
    }
  },
  between(val, valInf, valSup) {
    if (val < valInf) return valInf;
    if (val > valSup) return valSup;
    return val;
  },

  urlExists(url, callback) {
    fetch(url, { method: 'head' }).then(function(status) {
      callback(status.ok);
    });
  },

  getDiffTwoObjects(InitObj1, InitObj2) {
    const obj1 = JSON.parse(JSON.stringify(InitObj1));
    const obj2 = JSON.parse(JSON.stringify(InitObj2));
    Object.keys(obj1).forEach(key => {
      if (Array.isArray(obj1[key])) obj1[key].sort();
    });
    Object.keys(obj2).forEach(key => {
      if (Array.isArray(obj2[key])) obj2[key].sort();
    });

    let diff1 = Object.keys(obj1).reduce((diff, key) => {
      // console.log('diff', JSON.stringify(obj1[key]));
      // console.log('diff', JSON.stringify(obj2[key]));
      if (obj1[key] === obj2[key] || JSON.stringify(obj1[key]) === JSON.stringify(obj2[key]))
        return diff;
      return {
        ...diff,
        [key]: obj1[key]
      };
    }, {});
    let diff2 = Object.keys(obj2).reduce((diff, key) => {
      if (obj2[key] === obj1[key] || JSON.stringify(obj2[key]) === JSON.stringify(obj1[key]))
        return diff;
      return {
        ...diff,
        [key]: obj2[key]
      };
    }, {});

    return { ...diff1, ...diff2 };
  },

  isUrlValid(string) {
    try {
      new URL(string);
      return true;
    } catch (err) {
      return false;
    }
  },

  excludeFromArr(arr, exclude) {
    return arr.filter(el => !exclude.includes(el));
    // const excludeMap = exclude.reduce((all, item) => ({ ...all, [item]: true }), {});
    // return arr.filter(item => !excludeMap[item]);
  }

  // urlExists(url) {
  //   var http = new XMLHttpRequest();
  //   http.open('HEAD', url, false);
  //   http.send();
  //   if (http.status != 404) {
  //     console.log('HTTP', http);
  //     return true;
  //   } else return false;
  // }
};
